import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MarkAllNotificationsReadResponseDto, NotificationDto } from './notifications-api.types';

@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  constructor(private readonly http: HttpClient) {}

  get(): Observable<NotificationDto[]> {
    return this.http.get<NotificationDto[]>('/api/notifications');
  }

  markAsRead(id: string): Observable<NotificationDto> {
    return this.http.post<NotificationDto>(`/api/notifications/${encodeURIComponent(id)}/read`, {});
  }

  markAllAsRead(): Observable<MarkAllNotificationsReadResponseDto> {
    return this.http.post<MarkAllNotificationsReadResponseDto>('/api/notifications/read-all', {});
  }
}

